import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: "sortBySequence"
})

export class SortBySequencePipe implements PipeTransform {
  transform(collection: Array<any>, args: string): Array<any> {
    collection.sort((a: any, b: any) => {
      if (a.sequence < b.sequence) {
        return -1;
      } else if (a > b) {
        return 1;
      } else {
        return 0;
      }
    });
    return collection;
  }
}